import React from "react";
import { useAuth } from "../_helper/Auth/AuthProvider";
import { normalizeUserRole, roleMatches } from "../Layout/Sidebar/Menu";
import Error403 from "../Components/Pages/ErrorPages/ErrorPage403";

const RoleGate = ({ roles, children }) => {
  const { userData } = useAuth();
  if (!normalizeUserRole(userData?.role)) {
    return <Error403 />;
  }
  if (!roles || roles.length === 0) {
    return children;
  }
  if (!roleMatches(userData?.role, roles)) {
    return <Error403 />;
  }
  return children;
};

export default RoleGate;
